/** The two views of an asset's workspace. */
export type TAssetWorkspaceView = 'definition' | 'activity';

/**
 * Where a catalog card opens its asset, for every builder. A catalog can still
 * pass its own choice per list.
 */
export const ASSET_CARD_OPENS: TAssetWorkspaceView = 'definition';

/**
 * Query param that opens Definition with version history showing, so Activity's
 * version history button can land on the same panel.
 */
export const ASSET_VERSION_HISTORY_PARAM = 'versionHistory';

/** Which of an asset's versions its Definition shows. */
export type TAssetDocumentView = 'live' | 'draft';

/**
 * Query param naming the version Definition shows, `live` or `draft`. Activity
 * links carry it too, so the way back returns to the same version.
 */
export const ASSET_DOCUMENT_PARAM = 'document';

/**
 * Reads {@link ASSET_DOCUMENT_PARAM}; anything else names no version.
 *
 * @param value - The param's value
 * @returns The version, or undefined
 */
export function parseAssetDocumentView(
  value: string | null | undefined,
): TAssetDocumentView | undefined {
  return value === 'live' || value === 'draft' ? value : undefined;
}

/**
 * Adds {@link ASSET_DOCUMENT_PARAM} to a route, keeping any query it has.
 *
 * @param href - A route, with or without a query
 * @param view - The version to name; omitted leaves the route as it is
 * @returns The route naming the version
 */
export function withAssetDocumentView(
  href: string,
  view: TAssetDocumentView | undefined,
): string {
  if (!view) return href;
  return `${href}${href.includes('?') ? '&' : '?'}${ASSET_DOCUMENT_PARAM}=${view}`;
}
